import React from "react";

import { graphql } from "gatsby";

import Text from "cms/components/Text";
import { Container, Content } from "./HeaderTextBlock.styles";

export interface HeaderTextBlockProps extends Queries.SanityHeaderTextBlock {}

const HeaderTextBlock: React.FC<HeaderTextBlockProps> = ({ headline }) => (
  <Container>
    <Content>
      <Text variant="H2" as="h2">
        {headline}
      </Text>
    </Content>
  </Container>
);

export const query = graphql`
  fragment HeaderTextBlock on SanityHeaderTextBlock {
    _key
    _type
    headline
  }
`;

export default HeaderTextBlock;
